import { PrivacyAgreement } from 'src/presentation/pages'

export const makePrivacyAgreement = () => <PrivacyAgreement />
